<template>
<div class="kdx-ph-register">
    <div class="nav-crumb-top">
        <span>账号注册</span>
    </div>
    <div class="register-step-flow">
        <!-- 填写账号信息 -->
        <div class="register-wrapper">
            <div class="register-main">
                <div class="mc-register-main">
                    <div class="mc-register-mask clearfix">
                        <el-form :model="ruleForm" ref="registerForm" label-position="top" :rules="rules" class="new-register-form-wrappper">
                            <el-form-item label="学校" prop="schoolId">
                                <span class="apply-school" @click="applySchool">申请学校</span>
                                <div class="to-select-school-con">
                                    <el-select v-model="ruleForm.schoolId" clearable disabled filterable :filter-method="filterSchool" placeholder="请选择学校">
                                        <el-option prefix-icon="yk-icon-xuexiao" v-for="item in schoolList" :key="item.id" :label="item.name" :value="item.id">
                                        </el-option>
                                    </el-select>
                                    <div class="to-select-click" @click="toSelectSchool"></div>
                                </div>
                            </el-form-item>
                            <el-form-item label="账号" prop="userName">
                                <el-input v-model="ruleForm.userName" class="form_input" placeholder="请输入账号" maxlength="50"></el-input>
                            </el-form-item>
                            <el-form-item label="姓名" prop="displayName">
                                <el-input v-model="ruleForm.displayName" class="form_input" placeholder="请输入姓名" maxlength="20"></el-input>
                            </el-form-item>
                            <el-form-item label="手机号：" prop="phone">
                                <el-input v-model="ruleForm.phone" @blur="verificationMobile" class="form_input" placeholder="请输入您的手机号"></el-input>
                            </el-form-item>
                            <el-form-item label="身份证号：" prop="cardNumber">
                                <el-input v-model="ruleForm.cardNumber" class="form_input" placeholder="请输入用户名" maxlength="50"></el-input>
                            </el-form-item>
                            <el-form-item label="密码：" prop="password">
                                <el-input v-model="ruleForm.password" class="form_input" type="password" placeholder="请输入您的密码"></el-input>
                            </el-form-item>
                            <el-form-item label="确认密码：" prop="surePassword">
                                <el-input v-model="ruleForm.surePassword" class="form_input" type="password" placeholder="请输入您的密码"></el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div class="second-register-next-btn">
                        <el-button type="primary" :disabled="check" @click="register('registerForm')">立即注册</el-button>
                    </div>
                </div>
            </div>
        </div>
        <p class="p-enter-register clearfix">
            <span class="sp-left" @click="goHome">返回首页</span>
            <span class="sp-right" @click="enterLogin">点击登录</span>
        </p>
    </div>
</div>
</template>

<script>
import {
    MU_UPATE_AUTH,
    MU_UPATE_SCHOOL
} from "store/index";
export default {
    data() {
        return {
            ruleForm: {
                schoolId: "",
                userName: "",
                displayName: "",
                cardNumber: "",
                password: "",
                phone: "",
                captcha: "",
                userType: 2,
                surePassword: "",
            },
            schoolList: [],
            schoolInfo: [],
            rules: {
                schoolId: [{
                    required: true,
                    message: '学校不能为空',
                    trigger: 'blur'
                }],
                userName: [{
                    required: true,
                    message: '账号不能为空',
                    trigger: 'blur'
                }],
                displayName: [{
                    required: true,
                    message: '姓名不能为空',
                    trigger: 'blur'
                }],
                cardNumber: [{
                    required: true,
                    message: "身份证号不能为空",
                    trigger: "blur",
                }, ],
                password: [{
                    required: true,
                    message: "密码不能为空",
                    trigger: "blur",
                }, ],
                phone: [{
                    required: true,
                    message: "手机号不能为空",
                    trigger: "blur",
                }, ],
                captcha: [{
                    required: true,
                    message: "验证码不能为空",
                    trigger: "blur",
                }, ],
                surePassword: [{
                    required: true,
                    message: "密码不能为空",
                    trigger: "blur",
                }, ],
            },
            check: false,
        };
    },
    props: {
        schoolId: {
            type: String,
            default: ''
        }
    },
    created() {
        this.$store.dispatch(MU_UPATE_SCHOOL, {
            id: window.location.href,
        });
        this.getSchoolList();
    },
    computed: {
        association: function () {
            return this.$store.state.association;
        },
    },
    methods: {
        toSelectSchool() {
            this.$router.push({
                name: 'selectSchool',
                params: {
                    type: 'register'
                }
            });
        },
        /* 获取学校信息 */
        getSchoolList() {
            var that = this;
            this.$http.post("/api/XOrg/XLogin/getSchoolList", {
                SchoolType: "zwl",
            }).then(rst => {
                that.schoolList = rst.list;
                that.backOptions = rst.list;
                if (that.schoolId != '') {
                    that.ruleForm.schoolId = that.schoolId;
                }
            });
        },
        filterSchool: function (val) {
            var that = this;
            if (val) {
                // val存在
                that.schoolList = this.backOptions.filter(item => {
                    if (!!~item.name.indexOf(val) || !!~item.pinyin.indexOf(val)) {
                        return true;
                    }
                });
            } else {
                // val为空时，还原数组
                that.schoolList = this.backOptions;
            }
        },
        verificationMobile() {
            var re = /^1\d{10}$/;
            if (re.test(this.ruleForm.phone)) {
                return true;
            } else {
                this.$message.warning("手机号格式不正确");
                return false;
            }
        },
        goHome() {
            this.$router.push({
                name: "xIndex",
            });
        },
        enterLogin() {
            this.$router.push({
                name: "phLogin",
            });
        },
        register(formName) {
            console.log(this.association);
            if (this.ruleForm.password !== this.ruleForm.surePassword) {
                this.$message.warning("两次密码不一致");
                return false;
            } else {
                this.$http
                    .post("/api/XOrg/XLogin/register_new", {
                        userType: this.ruleForm.userType,
                        userName: this.ruleForm.userName,
                        displayName: this.ruleForm.displayName,
                        cardNumber: this.ruleForm.cardNumber,
                        phone: this.ruleForm.phone,
                        captcha: this.ruleForm.captcha,
                        password: this.ruleForm.password,
                        schoolId: this.ruleForm.schoolId
                    })
                    .then((rst) => {
                        if (rst.code > 0) {
                            this.$message({
                                message: rst.msg,
                                type: "success",
                            });
                            this.isShow = false;
                            this.$store.dispatch(MU_UPATE_AUTH).then((rt) => {});
                            this.goHome();
                        } else {
                            this.$message({
                                message: rst.msg,
                                type: "warning",
                            });
                        }
                    });
            }
        },
        applySchool() {
            this.$router.push({
                name: "applySchool"
            })
        }
    },
};
</script>

<style lang="scss">
.kdx-ph-register {
    height: 100%;
    background: #fff;
    overflow: auto;
    padding-bottom: 30px;

    .nav-crumb-top {
        width: 100%;
        line-height: 50px;
        font-size: 20px;
        color: #2d82ff;
        text-align: center;
        border-bottom: 2px solid #2d82ff;
    }

    .register-step-flow {
        width: 100%;
    }

    .register-main {
        width: 100%;

        .register-logo {
            width: 100%;
            text-align: center;
        }

        .mc-register-mask {
            width: 100%;

            .to-select-school-con {
                position: relative;
            }

            .to-select-click {
                position: absolute;
                left: 0;
                top: 10px;
                height: 40px;
                z-index: 100;
                width: 100%;
            }

            .new-register-form-wrappper {
                padding: 20px;

                .el-form-item {
                    margin-bottom: 0;
                }

                .el-form-item__label {
                    line-height: 20px;
                    font-size: 14px;
                    padding: 0;
                }

                .el-select {
                    width: 100%;
                }

                .el-input__inner {
                    width: 100%;
                    background-color: #fff;
                    border: 1px solid #cccccc;
                    color: #666666;
                }

                input::-webkit-input-placeholder {
                    /* WebKit browsers */
                    color: #cccccc;
                }

                input:-moz-placeholder {
                    /* Mozilla Firefox 4 to 18 */
                    color: #cccccc;
                }

                input::-moz-placeholder {
                    /* Mozilla Firefox 19+ */
                    color: #cccccc;
                }

                input:-ms-input-placeholder {
                    /* Internet Explorer 10+ */
                    color: #cccccc;
                }
            }

            .mc-select {
                position: relative;

                .wl-icon-xuexiao {
                    position: absolute;
                    top: 21px;
                    left: 6px;
                    z-index: 1000;
                    color: #c0c4d0;
                }

                .el-select {
                    width: 100%;

                    .el-input {
                        .el-input__inner {
                            padding-left: 30px;
                        }
                    }
                }
            }

            .el-input {
                margin: 10px 0;
            }

            .registerBtn {
                margin: 10px 0;
                width: 100%;
                background-color: #2d82ff;
                color: white;
            }

            .registerInfo {
                margin-top: 10px;
                width: 100%;

                .reCon {
                    float: left;

                    a {
                        color: #2d82ff;
                    }
                }

                .forget-pass {
                    float: right;
                }
            }

            .registerInfo:after {
                content: "";
                height: 0;
                display: block;
                clear: both;
                visibility: hidden;
            }

            .qu-register {
                position: relative;
                margin-top: 40px;
                width: 100%;
                height: 40px;

                div:first-child {
                    margin-top: 10px;
                    width: 100%;
                    height: 0;
                    border-top: 1px solid gray;
                }

                div:last-child {
                    position: absolute;
                    top: -5px;
                    left: 50%;
                    margin-left: -70px;
                    background-color: white;
                    width: 140px;
                    text-align: center;
                    color: gray;
                }
            }

            .wx-register {
                text-align: center;
                color: #2d82ff;

                i {
                    font-size: 40px;
                }
            }
        }

        .register_wx {
            .qu-register {
                position: relative;
                margin-top: 40px;
                width: 100%;
                height: 40px;

                div:first-child {
                    margin-top: 10px;
                    width: 100%;
                    height: 0;
                    border-top: 1px solid gray;
                }

                div:last-child {
                    position: absolute;
                    top: -5px;
                    left: 50%;
                    margin-left: -70px;
                    background-color: white;
                    width: 140px;
                    text-align: center;
                    color: gray;
                }
            }

            .wx-register {
                text-align: center;
                color: #2d82ff;

                i {
                    font-size: 40px;
                }
            }
        }
    }

    .el-form-item__error {
        right: 0;
        left: auto;
    }

    .second-register-next-btn {
        padding: 0 20px;

        .el-button {
            width: 100%;
            background: #2d82ff;
            border-color: #2d82ff;
        }

        .back-to-first {
            margin-top: 10px;
            font-size: 12px;
            color: #2d82ff;
            text-align: right;
            cursor: pointer;
        }
    }

    .p-enter-register {
        margin: 20px;
        color: #2d82ff;

        .sp-left {
            float: left;
        }

        .sp-right {
            float: right;
        }
    }

    .apply-school {
        position: absolute;
        top: -30px;
        right: 0;
        z-index: 2020;
        color: #2d82ff;
        cursor: pointer;
    }
}
</style>
